import React, { useState, useContext } from "react";
import { Button, List, Avatar, Typography } from "antd";
import { appContext } from "../../AppContext";
import { Card } from "./../../library/src/";
import { SafetyOutlined } from "@ant-design/icons";
//hooks
import { useNotification } from "./../../Utils/Hooks/useNotification";
import { useFetch } from "../../Utils/Hooks/useFetch";
import { useTranslation } from "react-i18next";
import azureLogo from "./../../media/logo_azure.png";
import prequestLogo from "./../../media/logo_prequest.png";
import microsoftLogo from "./../../media/logo_microsoft.png";
import windowsLogo from "./../../media/logo_windows.png";
import organisationLogo from "./../../media/logo_organisation.png";

export default function SsoConnectionsCard({
  currentUser: propsCurrentUser,
  isRefresh: propsIsRefresh,
}) {
  const [appState] = useContext(appContext);
  const [isLoading, setIsLoading] = useState(true);
  const [createNotification, NotificationType] = useNotification();
  const [doFetch, FetchType] = useFetch();
  const { t } = useTranslation(["user", "utils"]);

  function onClickSSOVerification() {
    doFetch(
      `/Email/SendSSOValidationMail/${propsCurrentUser.id}`,
      FetchType.POST
    ).then((response) => {
      if (response.isSuccess) {
        createNotification(
          NotificationType.SUCCESS,
          t("notifications.sendSSOEmailSuccess.title"),
          t("notifications.sendSSOEmailSuccess.message")
        );

        setIsLoading(true);
        return;
      }

      createNotification(
        NotificationType.ERROR,
        t("notifications.sendSSOEmailFailure.title"),
        t("notifications.sendSSOEmailFailure.message")
      );
    });
  }

  function deleteRow(id) {
    doFetch(
      `/usermanagement/${propsCurrentUser.id}/deleteuserlogin/${id}`,
      FetchType.DELETE
    ).then((response) => {
      if (response.isSuccess) {
        createNotification(
          NotificationType.SUCCESS,
          t("notifications.ssoRemovedSuccess.title"),
          t("notifications.ssoRemovedSuccess.message")
        );

        propsIsRefresh(true);
        return;
      }

      createNotification(
        NotificationType.ERROR,
        t("notifications.ssoRemovedFailure.title"),
        t("notifications.ssoRemovedFailure.message")
      );
    });
  }

  const getLogo = {
    windows: windowsLogo,
    azure: azureLogo,
    prequest: prequestLogo,
    microsoft: microsoftLogo,
    default: organisationLogo,
  };

  const getDisplayName = {
    windows: "Windows SSO",
    azure: "Microsoft Azure SSO",
    prequest: "Prequest SSO",
    microsoft: "Microsoft SSO",
    default: "Organisation SSO",
  };

  return (
    <Card title={t("ssoConnectionsDataTile")} marginBottom>
      {propsCurrentUser.userLogins.length !== 0 ? (
        <List
          itemLayout="horizontal"
          dataSource={propsCurrentUser.userLogins}
          renderItem={(item) => (
            <List.Item
              key={item.sid}
              actions={[
                appState.user.isAdministrator && (
                  <Button onClick={() => deleteRow(item.id)}>
                    {t("utils:buttons.disconnect")}
                  </Button>
                ),
              ]}
            >
              <List.Item.Meta
                avatar={
                  <Avatar shape="square" size={48} src={getLogo[item.scheme]} />
                }
                title={<Typography>{getDisplayName[item.scheme]}</Typography>}
                description={item.sid}
                style={{ justifyContent: "center" }}
              />
            </List.Item>
          )}
        />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: 24,
          }}
        >
          <Button
            onClick={() => onClickSSOVerification()}
            icon={<SafetyOutlined />}
            disabled={propsCurrentUser.email === ""}
          >
            {t("user.ssoEnable")}
          </Button>
          {propsCurrentUser.email === "" && (
            <Typography.Text type="secondary" style={{ marginTop: 16 }}>
              {t("user.ssoRequiresMail")}
            </Typography.Text>
          )}
        </div>
      )}
    </Card>
  );
}
